import { Typography, TypographyProps } from "@mui/material"
import React from "react"
import { TitleFont } from "src/theme"

export function Subheading(props: TypographyProps) {
  return (
    <Typography
      variant="h2"
      fontWeight={600}
      fontFamily={TitleFont}
      sx={{
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        backgroundImage: "linear-gradient(31deg, rgb(0, 0, 0) 0%, rgb(135, 21, 173) 100%)",
        fontSize: { lg: "3.75rem", md: "3.25rem", xs: "2.5rem" },
        fontVariationSettings: "'GRAD' 150",
        "html.dark &": {
          backgroundImage:
            "linear-gradient(135deg, rgb(255, 255, 255) 0%, rgb(160, 104, 252) 100%)",
        },
        textAlign: "center",
      }}
      {...props}
    />
  )
}
